// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'practiceManagement.prospect.title': 'Tell us about your business',
    'practiceManagement.prospect.invitedBy': '{practice} has asked you to set up your organisation.',
    'practiceManagement.prospect.legalName': 'Registered business name',
    'practiceManagement.prospect.tradingName': 'Trading name (if different)',
    'practiceManagement.prospect.jurisdiction': 'Where is your business registered?',
    'practiceManagement.prospect.yearEnd': 'Financial year end',
    'practiceManagement.prospect.paymentTitle': 'Payment details',
    'practiceManagement.prospect.paymentWhy': 'Your subscription is billed to you. Your accountant cannot set up your organisation until this is provided.',
    'practiceManagement.prospect.submit': 'Send to my accountant',
    'practiceManagement.prospect.submitted': 'Thank you — your accountant has what they need.',
    'practiceManagement.prospect.expired': 'This link has expired',
    'practiceManagement.prospect.expiredHelp': 'Ask {practice} to send you a new one.',
    'practiceManagement.prospect.optional': 'Optional',
    'practiceManagement.prospect.industry': 'What does your business do?',
    'practiceManagement.prospect.industryHelp': 'If you are not sure which to choose, leave it blank — your accountant will set it.',
    'practiceManagement.prospect.registrationTitle': 'Registration numbers',
    'practiceManagement.prospect.registrationHelp': 'If you do not have these to hand, leave them blank and your accountant will add them.',

    // Added by frontend-06. The keys above were written by frontend-02 from the
    // package's message table; the form needs a label for every field it asks
    // for, a name for every state it can be in, and a word for every failure it
    // can show. None of them names a registration number or a country — those
    // labels come from the API descriptor (onboarding-05), so adding a key here
    // would create a second vocabulary that disagrees with the stored one.
    'practiceManagement.prospect.validUntil': 'This link is valid until {date}.',
    'practiceManagement.prospect.businessSection': 'Your business',
    'practiceManagement.prospect.contactSection': 'Who should we speak to?',
    'practiceManagement.prospect.entityType': 'What kind of business is it?',
    'practiceManagement.prospect.entityTypeHelp': 'For example, a limited company, a partnership or a sole trader.',
    'practiceManagement.prospect.contactName': 'Your name',
    'practiceManagement.prospect.contactEmail': 'E-mail address',
    'practiceManagement.prospect.contactTelephone': 'Telephone number',
    'practiceManagement.prospect.yearEndHelp': 'The month your accounts are made up to.',
    'practiceManagement.prospect.chooseOne': 'Please choose one',
    'practiceManagement.prospect.nameOnCard': 'Name on card',
    'practiceManagement.prospect.cardDetails': 'Card details',
    'practiceManagement.prospect.cardUnavailable': 'The secure card field could not be loaded. Refresh the page and try again.',
    'practiceManagement.prospect.cardCheckFailed': 'We could not check those card details. Try again.',
    'practiceManagement.prospect.loading': 'Fetching your form…',
    'practiceManagement.prospect.loadFailed': 'We could not open your form.',
    'practiceManagement.prospect.submitFailed': 'We could not send your details.',
    'practiceManagement.prospect.checkFields': 'Please check the answers marked below.',
    'practiceManagement.prospect.tryAgain': 'Try again',
    'practiceManagement.prospect.yourAccountant': 'your accountant',
    'practiceManagement.prospect.submittedHelp': 'Here is what you sent. If any of it is wrong, ask {practice} for a fresh link.',
    'practiceManagement.prospect.notProvided': 'Not provided',

    // Added by onboarding-04. A live link now asks the prospect to sign in
    // before the form renders (the account owns everything they send), so the
    // page needs words for that hand-off and for the account it comes back
    // with. Dead links keep the copy above — they never mention signing in.
    'practiceManagement.prospect.signInTitle': 'Sign in to continue',
    'practiceManagement.prospect.signInWhy': 'Everything you send here — including any payment details — belongs to your account, so {practice} can set your organisation up for you to own.',
    'practiceManagement.prospect.signInAction': 'Sign in',
    'practiceManagement.prospect.registerAction': 'Create an account',
    'practiceManagement.prospect.signedInAs': 'You are signed in as {name}.',
    'practiceManagement.prospect.wrongAccount': 'Sign in as somebody else',
};
